import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { fmtDate } from "@/api";

const L_STYLE = { Pending: "text-warning border-warning/40", Approved: "text-success border-success/40", Rejected: "text-danger border-danger/40" };

export default function EmpLeaves() {
  const [leaves, setLeaves] = useState([]);
  const [form, setForm] = useState({ from_date: "", to_date: "", reason: "" });
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/leaves").then((r) => setLeaves(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leaves", form);
      toast.success("Leave request sent to supervisor");
      setForm({ from_date: "", to_date: "", reason: "" });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    setBusy(false);
  };

  return (
    <div className="p-5 space-y-5" data-testid="emp-leaves-page">
      <h1 className="font-heading text-xl font-bold">Leave Requests</h1>
      <form onSubmit={submit} className="bg-surface border border-border rounded-2xl p-4 space-y-3" data-testid="leave-form">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs text-muted-foreground">From</label>
            <input data-testid="leave-from-input" type="date" value={form.from_date} onChange={(e) => setForm({ ...form, from_date: e.target.value })} required
              className="w-full mt-1 bg-background border border-border rounded-xl px-3 py-3 [color-scheme:dark]" />
          </div>
          <div>
            <label className="text-xs text-muted-foreground">To</label>
            <input data-testid="leave-to-input" type="date" value={form.to_date} onChange={(e) => setForm({ ...form, to_date: e.target.value })} required
              className="w-full mt-1 bg-background border border-border rounded-xl px-3 py-3 [color-scheme:dark]" />
          </div>
        </div>
        <textarea data-testid="leave-reason-input" placeholder="Reason" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })}
          className="w-full bg-background border border-border rounded-xl px-4 py-3 min-h-[80px]" />
        <button data-testid="leave-submit-button" type="submit" disabled={busy}
          className="w-full py-4 rounded-xl bg-primary text-primary-foreground font-heading font-extrabold disabled:opacity-50">
          {busy ? "Sending…" : "REQUEST LEAVE"}
        </button>
      </form>
      <div className="space-y-2" data-testid="emp-leaves-list">
        {leaves.map((l) => (
          <div key={l.id} className="bg-surface border border-border rounded-xl p-4">
            <div className="flex items-center justify-between">
              <div className="font-medium text-sm">{fmtDate(l.from_date)} → {fmtDate(l.to_date)}</div>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${L_STYLE[l.status]}`}>{l.status}</span>
            </div>
            <div className="text-xs text-muted-foreground mt-1">{l.reason || "—"} {l.approved_by && `· by ${l.approved_by}`}</div>
          </div>
        ))}
        {leaves.length === 0 && <div className="text-center text-muted-foreground text-sm py-6">No requests yet</div>}
      </div>
    </div>
  );
}
